import { isMaskedValue, toTitleCase } from '../../../../utils/utils';
import { DATE_FORMATS, formatDateByFormat, formatTenureYears } from '../../../../utils/dateUtils';
import { DirectorTableRow } from './useManagementProfileTabLogic';

// Plain-text getters for the 3 composite/derived columns (D6/D7) — `tenure` and `contact`
// have no backing wire field at all, and `name` combines the raw field with title-casing.
// These feed DataTable's `valueGetterMap` (used wherever a plain value is needed, e.g.
// column export/sort) — the visual cell itself is a COMPONENT renderer
// (see managementProfileColumnRenderers.tsx) that builds the richer avatar/link markup.

export const nameValueGetter = (row: DirectorTableRow): string => (row?.name ? toTitleCase(row.name) : '');

export const tenureValueGetter = (row: DirectorTableRow): string => {
    if (!row?.tenureBeginDate) return '';
    const years = formatTenureYears(row.tenureBeginDate, row.tenureEndDate);
    const start = formatDateByFormat(row.tenureBeginDate, DATE_FORMATS.MONTH_SHORT_YEAR);
    const end = row.tenureEndDate ? formatDateByFormat(row.tenureEndDate, DATE_FORMATS.MONTH_SHORT_YEAR) : row.isActive ? 'Present' : '';
    return `${years} (${start} - ${end})`;
};

// Reads the phone through phoneValueGetter rather than the raw row: a masked vendor value is
// not the director's number, and this column would otherwise present it as one.
export const contactValueGetter = (row: DirectorTableRow): string => [row?.email, phoneValueGetter(row)].filter(Boolean).join(', ');

export const phoneValueGetter = (row: DirectorTableRow): string => (isMaskedValue(row?.phone) ? '' : row?.phone ?? '');

export const managementProfileValueGetterMap: Record<string, (row: DirectorTableRow) => string> = {
    name: nameValueGetter,
    tenure: tenureValueGetter,
    contact: contactValueGetter,
    phone: phoneValueGetter,
};
